import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { analyticsApiSlice } from '../../../api/rtk/base/slices/analyticsApiSlice';
import { uniqueValues } from '../../../features/dataFormatFunctions/dataFormatter';
import { getItemWebStorage, setItemWebStorage } from '../../../features/webStorageSaver/webStorageSaver';
import { store } from '../../../stateManagement/store';
import { classNames } from 'primereact/utils';
import ToastMessageContainer from '../../toastMessageContainer/ToastMessageContainer';
import { useDispatch } from 'react-redux';
import { setToastMessageContainerClearButtonIsClicked, showToastMessage } from '../../../stateManagement/reducers';

const check_filter_icon = require('../../../assets/images/icons/check_filter_icon.svg').default

// Компонент - секция с выбором фильтров для составления сводного отчета
export function AnalyticsFilterSection() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    // получение названия типа объекта из url
    const { objectTypeName }: any = useParams();
    let showNoValueWarning = false
    let uniqueObjectNames: any
    let objectTranslateNames: any = []
    // получение типов объектов из localStorage
    const objectTypes = getItemWebStorage("objectTypes")
    // при отсутствии типа объекта понимаем, что типов объектов несколько
    if (!objectTypeName) {
        // получаем названия типов объектов
        const objectNames = getItemWebStorage('analytics')?.chosenObjects
        showNoValueWarning = !objectNames
        // получение уникальных названий типов объектов
        uniqueObjectNames = objectNames && objectNames.filter(uniqueValues)
        // получаем список названий типов объектов на русском
        uniqueObjectNames && uniqueObjectNames.map((item: any) => {
            let objectTypeName = objectTypes.find((objectType: any) => objectType.caption === item)?.name
            objectTranslateNames.push(objectTypeName)
        })
    }
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const objectName = objectTypes.find((objectType: any) => objectType.name === objectTypeName)?.caption
    const token = store.getState().auth.tokens.app
    const [selectedFilterValues, setSelectedFilterValues] = useState<Array<string>>([]);
    const [selectedGroupingFilter, setSelectedGroupingFilter] = useState<any>(null);
    const [selectedAggregateFilter, setSelectedAggregateFilter] = useState<any>(0);
    const [filterValuesOptions, setFilterValuesOptions] = useState<any>(null);
    const [filterValues, setFilterValues] = useState<any>(null);
    const [showFilterValuesList, setShowFilterValuesList] = useState(false);
    const [showSingleRoadOptions, setShowSingleRoadOptions] = useState(false);
    const [isItGroupSelect, setIsItGroupSelect] = useState<any>(null);
    const [showNoValuesWarning, setShowNoValuesWarning] = useState<any>(false);
    const [fetchfilterValues] = analyticsApiSlice.useLazyFetchFilterValuesQuery();
    const [groupingsError, setGroupingsError] = useState<boolean>(false);
    const [filterValuesError, setFilterValuesError] = useState<boolean>(false);
    const [loadingGroupings, setLoadingGroupings] = useState<boolean>(false);

    useEffect(() => {
        // обнуляем параметры Начало и Конец
        setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), Position: null, Ending: null })
        // проверка на наличие выбранного фильтра
        if (!selectedAggregateFilter) {
            setShowFilterValuesList(false)
        }
        // проверка состояний фильтров
        if (filterValues && filterValues.FilterValues) {
            handleGroupCheckState()
            handleSingleRoadChosen()
        }
    }, [selectedFilterValues]);

    async function fetchGroupingFilters(filterClassId: any) {
        try {
            const response = await fetch(`${currentApiUrl}/reports/aggregate/groupings?ClassId=${filterClassId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
            });
            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            const groupingFilters = await response.json();
            return groupingFilters
        } catch (error) {
            console.error('Fetch error:', error);
            // Выводим сообщение об ошибке в консоль
        }
    }

    let aggregateFilterOptions: any = []

    const [groupingFilterOptionsState, setGroupingFilterOptionsState] = useState<any>([]);
    // запрос на получение фильтров для данного типа объета
    let {
        data: aggregateFilters,
        isError: filtersLoadError,
        refetch: refetchAggregateFilters,
        isLoading: loadingFilters
    } = analyticsApiSlice.useFetchAggregateFiltersQuery({})

    useEffect(() => {
        if (loadingGroupings) {
            dispatch(setToastMessageContainerClearButtonIsClicked(true))
        }
    }, [loadingGroupings])

    // добавление фильтров в качестве значений для выбора в Select
    aggregateFilters && aggregateFilters.Filters.map((item: any) => {
        aggregateFilterOptions.push({ label: item.Name, value: item.ID })
    })

    async function getGroupingFilterOptions(objectTypeName: any) {
        let groupingFilterOptions: any = []
        // при наличии единственного типа объекта
        if (objectTypeName) {
            setLoadingGroupings(!loadingGroupings)
            let objectClassId
            // сохранение ClassId текущего типа объекта
            objectClassId = objectTypes.find((objectType: any) => objectType.name === objectTypeName)?.classId
            setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), CurrentObjectClassesIds: '' })
            setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), CurrentObjectClassId: objectClassId })

            // запрос на получение группировок для данного типа объета
            let groupingFilters: any = await fetchGroupingFilters(objectClassId)
            if (!groupingFilters) {
                setGroupingsError(true)
                dispatch(showToastMessage({ messageText: 'Не удалось загрузить группировки', messageType: "error" }))
            }
            if (groupingFilters) {
                setGroupingsError(false)
            }
            // добавление группировок в качестве значений для выбора в Select
            groupingFilters && groupingFilters.Groupings.map((item: any) => {
                groupingFilterOptions.push({ label: item.Name, value: item.ID })
            })
            setGroupingFilterOptionsState(groupingFilterOptions)

        }
        // при наличии нескольких выбранных объектов
        else {
            setLoadingGroupings(!loadingGroupings)
            let groupingFiltersArray: any = []
            let objectsClassesIds: any = []
            await Promise.all(await objectTranslateNames.map(async (item: any) => {
                let objectClassId
                // составление списка ClassId для выбранных типов объектов
                if (item) {
                    objectClassId = objectTypes.find((objectType: any) => objectType.name === item)?.classId
                    objectsClassesIds.push(objectClassId)
                }
                // запрос на получение группировок для каждого типа объекта в цикле
                let groupingFiltersForArray: any = await fetchGroupingFilters(objectClassId)
                // добавление каждого массива группировок в общий для дальнейшего определения самого большого
                groupingFiltersForArray && groupingFiltersArray.push(groupingFiltersForArray.Groupings)
            }))
            if (groupingFiltersArray.length < objectTranslateNames.length) {
                setGroupingsError(true)
                dispatch(showToastMessage({ messageText: 'Не удалось загрузить фильтры', messageType: "error" }))
            }
            if (groupingFiltersArray.length === objectTranslateNames.length) {
                setGroupingsError(false)
            }
            // сохранение списка ClassId для выбраннхы типов объектов в хранилище
            setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), CurrentObjectClassesIds: objectsClassesIds })
            setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), CurrentObjectClassId: '' })
            let length = 0
            let finalGroupingFilters: any
            // определение самого длинного массива группировок
            groupingFiltersArray.map((item: any) => {
                if (item.length > length) {
                    finalGroupingFilters = item
                }
            })
            // добавление группировок в качестве значений для выбора в Select  
            finalGroupingFilters && finalGroupingFilters.map((item: any) => {
                groupingFilterOptions.push({ label: item.Name, value: item.ID })
            })
            setGroupingFilterOptionsState(groupingFilterOptions)
        }
    }

    useEffect(() => {
        setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), FilterValues: [], FilterID: null, GroupID: null })
        getGroupingFilterOptions(objectTypeName)
        refetchAggregateFilters()
    }, [objectTypeName])

    // обработчик нажатия на кнопку составления отчета
    function submitReport() {
        // сохранение параметров фильтрации
        setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), FilterValues: selectedFilterValues })
        // при отсутствии выбранных значений и выбранных значений Select отличных от 'Нет' вызываем ошибку
        if (selectedFilterValues.length === 0 && selectedAggregateFilter !== 0) {
            setShowNoValuesWarning(true)
        }
        // иначе перенаправляем на страницу отчета
        else {
            navigate('/app/analyticsReport')
        }
    }

    // функция для выбора значения в Select группировок
    function changeGroupingFilter(e: any) {
        setSelectedGroupingFilter(e.value)
        setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), GroupID: e.value })
    }

    // функция для выбора значения в Select фильтров
    async function changeAggregateFilter(e: any) {
        setSelectedFilterValues([])
        setFilterValuesOptions(null)
        setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), FilterValues: [] })
        setSelectedAggregateFilter(e.value)
        setShowNoValuesWarning(false)
        setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), FilterID: e.value })
        const filterId = aggregateFilters.Filters.find((x: any) => x.ID === e.value).ID
        setShowFilterValuesList(e.value !== "(нет)")
        const options = await fetchfilterValues({ filterId })
        if (options?.isError && e.value != 0) {
            dispatch(showToastMessage({ messageText: 'Не удалось загрузить значения фильтра', messageType: "error" }))
            setFilterValuesError(true)
        }
        if (!options?.isError) {
            setFilterValuesError(false)
            setFilterValues(await options.data)
            const optionNames: any = []
            if (await !options.data?.Parents) {
                setIsItGroupSelect(false)
                await options.data.FilterValues && await options.data.FilterValues.map((item: any) => {
                    optionNames.push({ label: item.Name, value: item.ID })
                })
            } else {
                setIsItGroupSelect(true)
                await options.data.Parents && await options.data.Parents.map((item: any) => {
                    let parent = { label: item.Name, items: options.data.FilterValues.filter((el: any) => el.ParentID === item.ID).map((filteredEl: any) => { return { label: filteredEl.Name, value: filteredEl.ID } }) }
                    optionNames.push(parent)
                })
            }
            setFilterValuesOptions(optionNames)
        }
    }

    // обработчик выбора единственной автомобильной дороги в качестве фильтра
    function handleSingleRoadChosen() {
        if (aggregateFilterOptions.find((item: any) => item.value === selectedAggregateFilter).label === "Автомобильная дорога" && selectedFilterValues.length === 1) {
            setShowSingleRoadOptions(true)
        } else {
            setShowSingleRoadOptions(false)
        }
    }

    // Обработчик для проверки выбранных значений и изменения стилей Checkbox при раскрытии Select
    function handleGroupCheckState() {
        filterValuesOptions && filterValuesOptions.map((parent: any) => {
            const children = parent.items ?? filterValuesOptions
            let selectedGroupValuesNum: number = 0
            let fullGroupSelected: boolean = false
            if (selectedFilterValues.length > 0) {
                children.map((item: any) => {
                    if (selectedFilterValues.find((filterValue: any) => filterValue === item.value)) {
                        selectedGroupValuesNum++
                    }
                    fullGroupSelected = selectedGroupValuesNum === children.length
                })
            }
            if (parent) {
                if (fullGroupSelected) {
                    document.getElementById(parent.label)?.classList.add('p-highlight')
                    document.getElementById(parent.label + '-check')?.classList.remove('d-none')
                    document.getElementById(parent.label + '-check')?.classList.add('d-block')
                }
                if (!fullGroupSelected) {
                    document.getElementById(parent.label)?.classList.remove('p-highlight')
                    document.getElementById(parent.label + '-check')?.classList.remove('d-block')
                    document.getElementById(parent.label + '-check')?.classList.add('d-none')
                }
            }
        })
    }

    // обработчик выбора целой группы значений (Выбор оставшихся значений в группе / Отключение всех значений + Изменение стилей)
    function setSelection(option: any) {
        let items = option.items
        let selectedGroupValuesNum: number = 0
        let fullGroupSelected: boolean = false

        items.map((item: any) => {
            if (selectedFilterValues) {
                if (selectedFilterValues.filter((filterValue: any) => filterValue === item.value).length > 0) {
                    selectedGroupValuesNum = selectedGroupValuesNum + 1
                }
                fullGroupSelected = selectedGroupValuesNum === items.length
            }
        })

        if (fullGroupSelected) {
            let selected = selectedFilterValues
            items.map((item: any) => {
                let index = selected.findIndex((selectedItem: any) => selectedItem === item.value)
                if (index > -1) {
                    selected.splice(index, 1)
                }
            })
            setSelectedFilterValues([...selected])
            document.getElementById(option.label)?.classList.remove('p-highlight')
            document.getElementById(option.label + '-check')?.classList.remove('d-block')
            document.getElementById(option.label + '-check')?.classList.add('d-none')
        } else {
            let selected2 = selectedFilterValues ?? []
            let notYetSelected: any = []
            items.map((item: any) => {
                let itemAlreadySelected = selected2.includes(item.value)
                if (!itemAlreadySelected) {
                    notYetSelected.push(item.value)
                }
            })
            setSelectedFilterValues([...selectedFilterValues, ...notYetSelected])
            document.getElementById(option.label)?.classList.add('p-highlight')
            document.getElementById(option.label + '-check')?.classList.remove('d-none')
            document.getElementById(option.label + '-check')?.classList.add('d-block')
        }
    }

    // Шаблон для отображения группы значений
    function getGroupedItemTemplate(option: any) {
        return (
            <>
                <div className="d-flex align-items-center" style={{ cursor: "pointer" }} onClick={() => { setSelection(option) }}>
                    <div className="p-checkbox p-component me-2" data-pc-section="checkboxcontainer" >
                        <div className="p-checkbox-box" id={option.label} data-pc-section="checkbox">
                            <img src={check_filter_icon} id={`${option.label}-check`} alt="" />
                        </div>
                    </div>
                    <div>{option.label}</div>
                </div>
            </>
        );
    }

    // функция для отображения правильного спряжения слов в зависимости от числа
    function declOfNum(number: number, words: any) {
        return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
    }

    // Шаблон для отображения количества выбранных значений
    function getPanelFooterTemplate() {
        const length = selectedFilterValues ? selectedFilterValues.length : 0;
        return (
            <div className="py-2 px-3">
                <b>{length}</b> {declOfNum(length, ['значение', 'значения', 'значений'])} {declOfNum(length, ['выбрано', 'выбраны', 'выбраны'])}.
            </div>
        );
    }

    // Функция выбора значения в Multiselect значений фильтрации или группировок
    function multiSelectChange(event: any) {
        setSelectedFilterValues(event.value)
        setShowNoValuesWarning(false)
        noCloseMulti(event)
    }

    function noCloseMulti(event: any) {
        event.originalEvent.stopPropagation();
    }

    useEffect(() => {
        if (filtersLoadError) {
            dispatch(showToastMessage({ messageText: 'Не удалось загрузить фильтры', messageType: "error" }))
        }
    }, [filtersLoadError])

    let filterRowClassName = classNames({
        "filter-row": objectName
    })

    return (
        <>
            {!showNoValueWarning
                ?
                <>
                    <div className="analytics-filter-section">
                        <ToastMessageContainer />
                        <div className={filterRowClassName}>
                            <div className="filter-first-col">
                                <span>Объекты:</span>
                            </div>
                            {/* Список выбранных объектов */}
                            <div className="filter-sec-col" >
                                <span style={{ fontWeight: "600" }}>{objectName ? objectName : uniqueObjectNames?.join(', ')}</span>
                            </div>
                        </div>
                        <div className="filter-row">
                            <div className="filter-first-col">
                                <span>Группировать:</span>
                            </div>
                            <div className="filter-sec-col">
                                {/* Выбор категории группировки */}
                                <Dropdown appendTo="self" panelClassName='analytics-group-dropdown-panel' value={selectedGroupingFilter} onChange={(e) => changeGroupingFilter(e)} disabled={groupingFilterOptionsState.length == 0} options={groupingFilterOptionsState}
                                    placeholder={groupingsError ? 'Ошибка' : (groupingFilterOptionsState.length > 0 ? "(нет)" : "Загрузка...")} scrollHeight="250px" emptyMessage="Нет вариантов." />
                            </div>
                        </div>
                        <div className="filter-row">
                            <div className="filter-first-col">
                                <span>Фильтр:</span>
                            </div>
                            <div className="filter-sec-col">
                                {/* Выбор категории фильтров */}
                                <Dropdown appendTo="self" panelClassName='analytics-filter-dropdown-panel' value={selectedAggregateFilter} onChange={(e) => changeAggregateFilter(e)} disabled={aggregateFilterOptions.length == 0} options={aggregateFilterOptions}
                                    placeholder={filtersLoadError ? 'Ошибка' : (aggregateFilterOptions.length > 0 ? "(нет)" : "Загрузка...")} scrollHeight="250px" emptyMessage="Нет результатов." >
                                </Dropdown>
                            </div>
                        </div>

                        {showNoValuesWarning &&
                            <>
                                <div className="filter-row mt-0 align-items-start" style={{ height: "fit-content" }}>
                                    <div className="filter-first-col">
                                        <span>‏</span>
                                    </div>
                                    <div className="filter-sec-col">
                                        <Tag icon="pi pi-times" severity="danger" value="Укажите значение фильтра"></Tag>
                                    </div>
                                </div>
                            </>
                        }
                        {showFilterValuesList &&
                            <div className="card flex justify-content-center filter-values-div">
                                {/* Выбор значений фильтров */}
                                {isItGroupSelect
                                    ?
                                    <MultiSelect
                                        value={selectedFilterValues}
                                        onChange={(e) => multiSelectChange(e)}
                                        options={filterValuesOptions}
                                        display="chip"
                                        placeholder={filterValuesError ? 'Ошибка' : (filterValuesOptions != null ? "Выбрать значения фильтра" : "Загрузка...")}
                                        className="w-full md:w-20rem filter-values-multiselect"
                                        scrollHeight="500px"
                                        panelFooterTemplate={getPanelFooterTemplate}
                                        filter
                                        optionGroupLabel="label"
                                        optionGroupChildren="items"
                                        optionLabel="label"
                                        optionGroupTemplate={getGroupedItemTemplate}
                                        emptyFilterMessage="Нет результатов."
                                        onShow={handleGroupCheckState}
                                        disabled={filterValuesOptions == null}
                                    />
                                    :
                                    <MultiSelect
                                        value={selectedFilterValues}
                                        onChange={(e) => multiSelectChange(e)}
                                        options={filterValuesOptions}
                                        display="chip"
                                        placeholder={filterValuesError ? 'Ошибка' : (filterValuesOptions != null ? "Выбрать значения фильтра" : "Загрузка...")}
                                        className="w-full md:w-20rem filter-values-multiselect"
                                        scrollHeight="500px"
                                        panelFooterTemplate={getPanelFooterTemplate}
                                        filter
                                        optionLabel="label"
                                        emptyFilterMessage="Нет результатов."
                                        onShow={handleGroupCheckState}
                                        disabled={filterValuesOptions == null}
                                    />
                                }
                            </div>
                        }
                        {/* Доп. Фильтр при выбранной одной автомобильной дороги в качестве основного фильтра */}
                        {showSingleRoadOptions &&
                            <div className="d-flex filter-row roadSegmentOptions">
                                <div className="filter-first-col">
                                    <span className="me-5">Участок:</span>
                                </div>
                                <div className="filter-sec-col">
                                    <InputNumber type="text" className="p-inputtext-sm me-4" placeholder="Начало, км" onChange={(e: any) => setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), Position: e.value })} />
                                    <InputNumber type="text" className="p-inputtext-sm" placeholder="Окончание, км" onChange={(e: any) => setItemWebStorage('analytics', { ...getItemWebStorage('analytics'), Ending: e.value })} />
                                </div>
                            </div>
                        }
                        {/* Кнопка составления отчета */}
                        <div className="button-div">
                            <Button label={(loadingFilters) ? "" : "Составить отчёт"} severity="success" className="submit-report-btn" onClick={submitReport} disabled={loadingFilters} >
                                {(loadingFilters) &&
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        <span>Загрузка...</span>
                                    </>
                                }
                            </Button>
                        </div>
                    </div>
                </>
                :
                <div className="m-5 no-objects-warning-div">
                    <Card title="Не выбран объект" style={{ width: "fit-content" }}>
                        <p className="m-0">
                            <Button className="no-objects-redirect-button" onClick={() => navigate('selectObjects')} style={{ backgroundColor: "#66AFDF", color: "white", border: "0", fontWeight: "bold" }}>Выбрать</Button>
                        </p>
                    </Card>
                </div>
            }
        </>
    );
}

